module.exports = __webpack_public_path__ + "static/media/team-chanho.b4a05164.jpg";